angular.module('ikeweb.map').controller('CaptureMapController', ['captureMapFactory', 'pubSubService', 'captureMapTopics', 'mapTopics', 'functional', '$timeout',
    function(captureMapFactory, pubSubService, captureMapTopics, mapTopics, f, $timeout) {
        var self = this;
        var map;

        function setZoom(zoom) {
            map.setZoom(zoom);
        }

        function createMap(captures) {
            map = captureMapFactory.create(self.$element, self.center, captures);
            self.setZoom = f.debounce(setZoom, 50, $timeout);
            self.zoomIn = map.zoomIn;
            self.zoomOut = map.zoomOut;
            self.zoomFit = map.zoomToAllMarkers;
        }

        function destroy() {
            pubSubService.unsubscribe(captureMapTopics.MAP.CAPTURES.LOAD, createMap);
        }

        self.setElement = function($element) {
            $element.on('$destroy', destroy);
            self.$element = $element;
        };

        self.getZoom = function() {
            return map ? map.getZoom() : 0;
        };

        pubSubService.subscribe(captureMapTopics.MAP.CAPTURES.LOAD, createMap);
    }
]);



//////////////////
// WEBPACK FOOTER
// ./src/client/components/map/capture/capture.map.controller.js
// module id = 585
// module chunks = 0